var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2H9C5.22876 2 3.34315 2 2.17157 3.17157C1 4.34315 1 6.22876 1 10V12C1 15.7712 1 17.6569 2.17157 18.8284C3.34315 20 5.22876 20 9 20H10",
    stroke: "#0DA06E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 2H13C15.8284 2 17.2426 2 18.1213 2.87868C19 3.75736 19 5.17157 19 8V14C19 16.8284 19 18.2426 18.1213 19.1213C17.2426 20 15.8284 20 13 20H9",
    stroke: "#0DA06E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "83.33 100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1V21",
    stroke: "#0DA06E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.01c00a009931054a384af4207297e168.svg";
export { ForwardRef as ReactComponent };